import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class CambiarPasswordService {


    static updatePassword(userPassword, newPassword){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();

        return SharedService.httpPostCryptoUpdate(ApplicationConstants.updatePasswordUrl, { uid: uid, token: token, userPassword: userPassword, newPassword: newPassword}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/perfil/components/cambiar-password-modal/services/cambiarPasswordService.js